import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import date from '@galo-monitor/forms/validators/date.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const projectSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  start: flow(
    date({ t }),
    required({ t })
  )(Yup.string()),
  finish: flow(
    date({ t }),
    required({ t })
  )(Yup.string()),
  clientCompanies: required({ t, isNotText: true })(
    Yup.array().of(
      Yup.string()
    )
  ),
  users: required({ t, isNotText: true })(
    Yup.array().of(
      Yup.string()
    )
  )
})

export default projectSchema
